/**
 * Indicates whether the tolerance is at the seller's or buyer's option.
 * tag: 41075
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryStreamToleranceOptionSide {
  /** Buyer */
  Buyer = 1,
  /** Seller */
  Seller = 2,
}
